import React from 'react';
import {actionIcDelete24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {labels} from '../../../../util/utils';
import IconButton from '../../BaseComponentWrappers/MotifIconButton';

const EditAccountPSPIndexModalItem = (props) => {
	return (
		<section className="pspindex-list" key={props.id}>
			<section className="pspindex-listitem">
				<span className="pspindex-name" title={props.label}>
					{props.label}
				</span>
				<IconButton
					iconSource={actionIcDelete24px}
					iconType="button"
					iconTitle={labels.removePSPIndexLabel}
					onIconClick={() => {
						props.onItemClick(props);
					}}
				/>
			</section>
		</section>
	);
};

export default EditAccountPSPIndexModalItem;
